module.exports = __webpack_public_path__ + "media/img/event/sponsor/kuas-logo-4f985a9d490628cdf58da3c604f299ee.png";